(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["form-stock-check"] && !window.DesignMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
    const form = document.getElementById('formStockCheck');

    form.addEventListener('submit', function(event) {
        event.preventDefault();
        const pattern = document.querySelector('input[name="pattern-no"]').value.trim();
        console.log('Pattern Number:', pattern); // Debug log

        if (pattern) {
            const stockEntity = "IN%20Stock%20Available%20%E2%80%93%20Web";
            const url = `https://aspiringwalls-stockchecker.yetitech.nz/api/getStockItemsByPattern/${pattern}`;

            const headers = {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*'
            };

            axios.get(url, { headers })
                .then(response => {
                    const data = response.data;
                    console.log('API Response:', data); // Debug log
                    updateStockStatus(data, pattern);
                })
                .catch(error => {
                    console.error('Error fetching data from API:', error);
                });
        } else {
            alert('Please enter a valid pattern number.');
        }
    });

    function updateStockStatus(data, pattern) {
        const resultPort = document.querySelector("#stockStatus");
        const table = document.querySelector('.table-container');
        let resultHTML = '';

        if (data.value.length === 0 && data.patternExist == true) {
            resultHTML += `
                <tr class="table-row">
                    <td>${pattern}</td>
                    <td> - </td>
                    <td> - </td>
                    <td>Contact Cust Serv.</td>
                </tr>
            `;
        } else if (data.value.length === 0 && data.patternExist == false) {
            resultHTML += `
                <tr class="table-row">
                    <td>${pattern}</td>
                    <td> - </td>
                    <td> - </td>
                    <td>Product Missing</td>
                </tr>
            `;
        } else {
            data.value.forEach(item => {
                const available = parseFloat(item.Available).toFixed(0);
                resultHTML += `
                    <tr class="table-row">
                        <td>${item.StockCode.trim()}</td>
                        <td>${item.LotSerialNbr}</td>
                        <td>${isNaN(available) ? 0 : available}</td>
                        <td>Available</td>
                    </tr>
                `;
            });
        }

        console.log('Result HTML:', resultHTML); // Debug log
        resultPort.innerHTML = resultHTML;

        // Show table if data is available
        if (data.value) {
            table.style.display = 'table';
        } else {
            table.style.display = 'none';
        }
    }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["promo-fixed"]) return;
  try {
    
  function initPromoFixed(){
    var $ttpromofixed = $(".tt-promo-fixed"),
    	$promofixeddata = $(".promofixeddata"),
        $promofixedclose = $ttpromofixed.find(".tt-btn-close");
    
    if($('html').hasClass('touch-device') && $ttpromofixed.hasClass('hidden-mobile')) return false;
	if($ttpromofixed.hasClass('hidden-mobile') && $(window).width < 1025) return false;
    if($promofixeddata.length == 0) return false;
    
    setPromoFixedItem($ttpromofixed, $promofixeddata);
	showPromoFixed($ttpromofixed, $ttpromofixed.data('start'));
    
	showPromoFixedNextMessage($ttpromofixed, $promofixeddata, $promofixedclose)

    $promofixedclose.click(function(){
      $ttpromofixed.addClass('nonevent').fadeTo(100, 0);
    });
  }
  function showPromoFixedNextMessage($modal, $data, $close){
    var nextmin = $modal.data('min'),
        nextmax = $modal.data('max');
	var i = getRndInteger(nextmin, nextmax);
    setTimeout(function(){
      $close.trigger('click');
      setTimeout(function(){
        setPromoFixedItem($modal, $data);
        showPromoFixed($modal, 0);
        showPromoFixedNextMessage($modal, $data, $close);
      }, 100);
    }, i);
  }
  function getPromoFixedCustomProductIndex($promofixeddata){
    var min = 0,
        max = $promofixeddata.children().length;
    return getRndInteger(min, max);
  }
  function setPromoFixedItem($modal, $data){
    var i = getPromoFixedCustomProductIndex($data)
    var data = $data.children().eq(i);
    $modal.find('.tt-img').find('a').attr('href', data.data('url')).find('img').attr('src', data.data('image')).attr('alt', data.data('alt'));
    $modal.find('.pr_name').attr('href', data.data('url')).text(data.data('name'));
    
    var nummin = parseInt(data.data('min')),
    	nummax = parseInt(data.data('max')),
    	num = getRndInteger(nummin, nummax);
    $modal.find('.tt-info-value').text(num);

	if (typeof data.data('text') === typeof undefined) return false;
    var str = data.data('text').split('||'),
    	i = getRndInteger(0, str.length-1);
    $modal.find('.tt-info-text').text(str[i]);
  }
  function showPromoFixed($parent, delay){
    setTimeout(function(){
	  $parent.removeClass('nonevent').fadeTo(300, 1);
    }, delay);
  }
  function getRndInteger(min, max) {
    return Math.floor(Math.random() * (max - min) ) + min;
  }
  setTimeout(initPromoFixed, 300);

  } catch(e) { console.error(e); }
})();
})();
